export enum DiagnosticItemName {
    ETHERNAT_LAN_CONNECTION = "EtherLanConn",
    PING_PRIMARY_DNS = "PingPriDNS",
    PING_YAHOO = "PingYahoo",
    PING_OTHERS = "PingOther"
};

export type DiagnosticItem = { [key in DiagnosticItemName]: string };